<template>
  <section class="ma-4 ma-md-8">
    <print-app-brand />
    <print-event-header :event="event" />
    <t-page-title title="Acessos | Borderô" :on-print="print" />
    <v-form class="mb-8 no-print" @submit.prevent="handleFileUpload">
      <v-row>
        <v-col cols="12" md="6">
          <v-file-input
            v-model="file"
            variant="outlined"
            density="comfortable"
            accept=".csv"
            prepend-icon=""
            prepend-inner-icon="far fa-paperclip"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-btn
            color="primary"
            :disabled="loader.loading"
            size="large"
            block
            type="submit"
            class="no-print"
          >
            Filtrar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <!-- Resumo -->
    <v-row>
      <v-col cols="12">
        <h1> Resumo </h1>
      </v-col>
      <v-col>
        <v-table>
          <thead>
            <tr>
              <th class="font-weight-bold">
                Descrição
              </th>
            </tr>
            <tr>
              <th class="font-weight-bold">
                Valor
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Público Pagante</td>
              <td>
                {{ data.mapping }}
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-col>
    </v-row>
    <!-- Ingressos -->
    <v-row>
      <v-col cols="12">
        <h1> Ingressos </h1>
      </v-col>
      <v-col>
        <v-table>
          <thead>
            <tr>
              <th class="font-weight-bold">
                Setor
              </th>
              <th class="font-weight-bold">
                Tipo
              </th>
              <th class="font-weight-bold">
                Vendidos
              </th>
              <th class="font-weight-bold">
                Valor Unitário
              </th>
              <th class="font-weight-bold">
                Computados
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="data.length !== 0">
              <tr v-for="(item, index) in data" :key="index">
                <td> {{ item.Setor }} </td>
                <td> {{ item.TipodeIngresso }} </td>
                <td> {{ Math.max(parseInt(item.NumdeIngressos.replace('.', '')), 0) }} </td>
                <td> {{ $formatters.currency(parseFloat(item.valorNominal.replace(',', '.'))) }} </td>
                <td> {{ 0 }} </td>
              </tr>
              <tr>
                <td class="font-weight-bold">
                  Total
                </td>
                <td />
                <td class="font-weight-bold">
                  {{ data.reduce((a: number, b: Record<string, string>) => a + parseInt(b.NumdeIngressos.replace('.', '')), 0) }}
                </td>
                <td class="font-weight-bold">
                  {{
                    $formatters.currency(
                      data.reduce(
                        (a: number, b: Record<string, string>) => a +
                          (
                            parseInt(b.NumdeIngressos.replace('.', ''))
                            *
                            parseFloat(b.valorNominal.replace(',', '.'))
                          ),
                        0
                      )
                    )
                  }}
                </td>
                <td class="font-weight-bold">
                  {{ 0 }}
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="5" align="center">
                  <h4>Ainda não existem vendas online para este evento.</h4>
                </td>
              </tr>
            </template>
          </tbody>
        </v-table>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { ref, Ref } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import { useLoader } from '@/stores/loader'
import PrintAppBrand from '@/components/print/print-app-brand.vue'
import PrintEventHeader from '@/components/print/print-event-header.vue'
import Papa from 'papaparse'

const loader = useLoader()

interface Item {
  Setor: string
  TipodeIngresso: string
  NumdeIngressos: string
  valorNominal: string
}

const data: Ref<Item[]> = ref([])
const file: Ref<File | null> = ref(null)

const event = {
  title: 'Santos X Ceará',
  subtitle: 'Campeonato Brasileiro 2025',
  dates: {
    start: '12.MAI.25 - 20H00',
  },
  configuration: {
    mapping: {
      local: {
        name: 'Allianz Parque',
      },
    },
  },
}

const handleFileUpload = () => {
  if (file.value === null) return

  Papa.parse(
    file.value, {
      header: true, // Treat first row as headers
      skipEmptyLines: true, // Ignore empty rows
      complete: (results) => {
        data.value = results.data
      },
      error: (error) => {
        console.error('CSV Parse Error:', error)
      },
    })
}

function print() {
  window.print()
}
</script>
